import styled from "styled-components";

export const Styles = styled.div`
  background: var(--bg-item);
  color: var(--color-item);
  padding: 8px;
  border-radius: 8px;
  display: flex;
  justify-content: space-between;
  user-select: none;
  .container-day-item {
    width: 40px;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 4px;
    .weekday {
      height: 32px;
      width: 32px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-weight: 700;
      font-size: 16px;
      border-radius: 100%;

      &.active {
        background: #6a8dff;
        color: #fff;
      }
    }
  }
`;
